// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoModalStyles_container__3CFL9"};